import { UnderMaintenance } from '@/components/ui';

export const ReportRegister = () => {
    return <UnderMaintenance />;
};

ReportRegister.displayName = 'ReportRegister';
